module.exports = __webpack_public_path__ + "img/tab_1.50baf35d.png";